'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { BlogCategoriesRow } from '@/app/[locale]/blog/_components/BlogCategoriesRow';
import AppLink from '@/components/elementary/AppLink';
import { Scrollable } from '@/components/elementary/Scrollable';
import Heading from '@/components/typography/Heading';
import { cn } from '@/lib/styles';
import { EDITORS_PICK_TEST_IDS } from '@/lib/test-ids';
import { getArticleLink } from '@/utils/links';
export function EditorsPick(t0) {
  const $ = _c(12);
  const {
    component,
    className
  } = t0;
  const {
    title,
    articles
  } = component;
  if (!articles?.length) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("py-8 lg:pt-10 lg:pb-9 border-y border-brand-salmon", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = title && <Heading tag="h2" fontSize="headingMedium" className="mb-6">{title}</Heading>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== articles) {
    t3 = articles?.map(_temp);
    $[4] = articles;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <Scrollable className="h-66.5 md:h-62.5 lg:h-72.5" scrollableClassName="flex flex-col gap-4 max-h-66.5 md:max-h-62.5 lg:max-h-72.5 overflow-y-scroll" data-test-id={EDITORS_PICK_TEST_IDS.COMPONENT}>{t3}</Scrollable>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t4) {
    t5 = <div className={t1} data-test-id={EDITORS_PICK_TEST_IDS.COMPONENT}>{t2}{t4}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp(article) {
  return <div key={article.id} className="flex flex-col gap-2">{article.blogCategories && article.blogCategories.length > 0 && <BlogCategoriesRow categories={article.blogCategories} type="small" />}{article.slug && <AppLink href={getArticleLink(article.slug)} hrefMode="localized" size="none" className="w-fit" data-test-id={EDITORS_PICK_TEST_IDS.ARTICLE_LINK}><Heading textColor="link" tag="h3" fontSize="bodyRegularLarge" className="line-clamp-2">{article.title}</Heading></AppLink>}</div>;
}